module.exports = __webpack_public_path__ + "img/Falkland Islands.1b3a518f.svg";